import { FormGroup, ValidationErrors } from '@angular/forms';

export function changePasswordFormValidator(formGroup: FormGroup): ValidationErrors | null {
  const oldPasswordControl = formGroup.get('oldPassword');
  const newPasswordControl = formGroup.get('newPassword');
  const newPasswordConfirmationControl = formGroup.get('newPasswordConfirmation');

  if (oldPasswordControl.value === newPasswordControl.value) {
    newPasswordControl.setErrors({
      ...newPasswordControl.errors,
      passwordsEquality: 'REGULAR.ERROR_MESSAGES.NEW_PASSWORD.EQUAL_WITH_OLD',
    });
  } else if (newPasswordControl.errors) {
    const { passwordsEquality, ...errors }  = newPasswordControl.errors;
    newPasswordControl.setErrors(Object.keys(errors).length ? { ...errors } : null);
  }

  if (newPasswordConfirmationControl.value && newPasswordConfirmationControl.value !== newPasswordControl.value) {
    newPasswordConfirmationControl.setErrors({
      ...newPasswordConfirmationControl.errors,
      passwordsMatch: 'REGULAR.ERROR_MESSAGES.NEW_PASSWORD_CONFIRMATION.EQUAL_WITH_NEW',
    });
  } else if (newPasswordConfirmationControl.errors) {
    const { passwordsMatch, ...errors }  = newPasswordConfirmationControl.errors;
    newPasswordConfirmationControl.setErrors(Object.keys(errors).length ? { ...errors } : null);
  }

  return null;
}
